import { call, select, put, takeLatest } from 'redux-saga/effects'
import { ATTACK } from './constants';
import activePokemon from '../services/activePokemon';
import { selectActiveGame } from '../ActiveGame/selectors';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { attackEnd } from './actions';
import { closeContextMenu } from '../ActiveGame/actions';

function* attackTask(action) {
  const gameId = (yield select(selectActiveGame)).get('id');

  try {
    const game = yield call(activePokemon.attack, gameId, action.payload.get('moveId'), action.payload.get('picks').toJS());

    yield call(handleUpdateGame, game);
    yield put(closeContextMenu());
  } finally {
    // A refused attack (not enough energy, say) still ends the attempt; the error itself shows in the app's errors.
    yield put(attackEnd());
  }
}

function* attackWatcher() {
  yield takeLatest(ATTACK, attackTask);
}

export default [
  attackWatcher,
];
